import React, { useState } from "react";
import { Box, TextField, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import TextEditor from "../utils/TextEditor";

const customeTextFeild = {
  boxShadow: "0px 1px 2px 0px rgba(15, 22, 36, 0.05)",
  "& .MuiInput-underline:after": {
    borderBottomColor: "#B2BAC2",
  },
  "& .MuiOutlinedInput-input": {
    // padding: "15px 24px 15px 0px",
  },
  "& .MuiOutlinedInput-root": {
    // paddingLeft: "24px",
    "& fieldset": {
      borderColor: "",
    },
    "&:hover fieldset": {
      borderColor: "#969696",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#969696",
    },
  },
  "& .MuiInputBase-input.Mui-disabled": {
    color: "#333",
    WebkitTextFillColor: "#333",
    background: "#eee",
  },
};

const MetaTagAndDescription = ({
  metaTitle,
  setMetaTitle,
  metaDescription,
  setMetaDescription,
  metaKeywords,
  setMetaKeywords,
  pageDescription,
  setPageDescription,
  pageTitle,
  setPageTitle,
  pageTitleDescription,
  setPageTitleDescription,
  fieldIdPrefix = "",
}) => {
  return (
    <Box>
      <Grid container columnSpacing={3}>
        <Grid size={12}>
          <Typography
            variant="medium"
            color="text.main"
            gutterBottom
            sx={{ fontWeight: 500 }}
          >
            Meta Title
          </Typography>
          <TextField
            size="small"
            fullWidth
            id={`${fieldIdPrefix}meta_title`}
            placeholder="Enter Meta Title"
            variant="outlined"
            sx={{ ...customeTextFeild, mb: 3 }}
            value={metaTitle}
            onChange={(e) => {
              setMetaTitle(e.target.value);
            }}
          />
        </Grid>

        <Grid size={12}>
          <Typography
            variant="medium"
            color="text.main"
            gutterBottom
            sx={{ fontWeight: 500 }}
          >
            Meta Description
          </Typography>
          <TextField
            size="small"
            fullWidth
            id={`${fieldIdPrefix}meta_description`}
            placeholder="Enter Meta Description"
            variant="outlined"
            multiline
            rows={3}
            sx={{ ...customeTextFeild, mb: 3 }}
            value={metaDescription}
            onChange={(e) => {
              setMetaDescription(e.target.value);
            }}
          />
        </Grid>

        <Grid size={12}>
          <Typography
            variant="medium"
            color="text.main"
            gutterBottom
            sx={{ fontWeight: 500 }}
          >
            Meta Keywords
          </Typography>
          <TextField
            size="small"
            fullWidth
            id={`${fieldIdPrefix}meta_keywords`}
            placeholder="Enter Meta Keywords (comma separated)"
            variant="outlined"
            sx={{ ...customeTextFeild, mb: 3 }}
            value={metaKeywords}
            onChange={(e) => {
              setMetaKeywords(e.target.value);
            }}
          />
        </Grid>
        <Grid size={12}>
          <Typography
            variant="medium"
            color="text.main"
            gutterBottom
            sx={{ fontWeight: 500 }}
          >
            Page Title
          </Typography>
          <TextField
            size="small"
            fullWidth
            id={`${fieldIdPrefix}page_title`}
            placeholder="Enter Page Title"
            variant="outlined"
            sx={{ ...customeTextFeild, mb: 3 }}
            value={pageTitle}
            onChange={(e) => {
              setPageTitle(e.target.value);
            }}
          />
        </Grid>

        <Grid size={12}>
          <Typography
            variant="medium"
            color="text.main"
            gutterBottom
            sx={{ fontWeight: 500 }}
          >
            Page Title Description
          </Typography>
          <TextField
            size="small"
            fullWidth
            id={`${fieldIdPrefix}page_title_description`}
            placeholder="Enter Page Title Description"
            variant="outlined"
            multiline
            rows={3}
            sx={{ ...customeTextFeild, mb: 3 }}
            value={pageTitleDescription}
            onChange={(e) => {
              setPageTitleDescription(e.target.value);
            }}
          />
        </Grid>
        <Grid size={12}>
          <Typography
            variant="medium"
            color="text.main"
            gutterBottom
            sx={{ fontWeight: 500 }}
          >
            Page Description
          </Typography>
          <TextEditor
            convertedContent={pageDescription}
            setConvertedContent={setPageDescription}
            data={pageDescription}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default MetaTagAndDescription;
